import CallIcon from '@mui/icons-material/Call';
import WarningIcon from '@mui/icons-material/Warning';
import {
    Avatar,
    Badge,
    IconButton,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Tooltip,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';

import PriorityHighOutlinedIcon from '@mui/icons-material/PriorityHighOutlined';
import { useAppSelector } from '../../../../store/hooks';
import { HeaderDialerStatusPopover } from './HeaderDialerStatusPopover';

interface Props {
    isImpersonated: boolean;
    twilioDeviceCount: number;
    isDialerBootstrapped: boolean;
    isCompOnMenu?: boolean;
}

export default function HeaderActionsDialerStatus({
    isImpersonated,
    twilioDeviceCount,
    isDialerBootstrapped,
    isCompOnMenu = false,
}: Props) {
    const { classes } = useStyles();

    const phoneNumber = useAppSelector(state => state.user.dialerPhone);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    if (isCompOnMenu) {
        return (
            <>
                <MenuItem onClick={handleClick}>
                    <ListItemIcon>
                        <WarningIcon />
                    </ListItemIcon>
                    <ListItemText
                        primary={twilioDeviceCount > 0 ? 'Device Active' : 'No Device Registered'}
                    />
                </MenuItem>
                <HeaderDialerStatusPopover
                    anchorEl={anchorEl}
                    isImpersonated={isImpersonated}
                    audioDevicesCount={twilioDeviceCount}
                    phoneNumber={phoneNumber}
                    handleClose={handleClose}
                    isDialerBootstrapped={isDialerBootstrapped}
                />
            </>
        );
    }

    return (
        <>
            <Tooltip
                title={
                    twilioDeviceCount > 0
                        ? 'Stay In Contact Phone: Ready to receive calls.'
                        : 'Stay In Contact Phone: Disabled'
                }
            >
                <Badge
                    badgeContent={<PriorityHighOutlinedIcon sx={{ fontSize: 12 }} />}
                    color="warning"
                    overlap="circular"
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    invisible={twilioDeviceCount > 0}
                >
                    <Avatar
                        className={
                            isDialerBootstrapped && twilioDeviceCount > 1 ? classes.showActive : ''
                        }
                    >
                        <IconButton
                            onClick={handleClick}
                            size="large"
                            className={classes.iconButton}
                        >
                            <CallIcon />
                        </IconButton>
                    </Avatar>
                </Badge>
            </Tooltip>
            <HeaderDialerStatusPopover
                anchorEl={anchorEl}
                isImpersonated={isImpersonated}
                audioDevicesCount={twilioDeviceCount}
                phoneNumber={phoneNumber}
                isDialerBootstrapped={isDialerBootstrapped}
                handleClose={handleClose}
            />
        </>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    showActive: {
        backgroundColor: theme.palette.success.main,
    },
    iconButton: {
        padding: theme.spacing(1),
        '& .MuiSvgIcon-root': {
            fill: theme.palette.appHeader.contrastText,
        },
    },
}));
